export default __webpack_public_path__ + "static/media/more.2a9cbf36.svg";